import{e as n}from"./_rollupPluginBabelHelpers-4a805435.js";import{css as r}from"styled-components";var e,l=function(l){return r(e||(e=n(["\n    * {\n        fill: ",";\n    }\n"])),l)};export{l as default};
